'use client'

import { IModalActions, ModalTypes } from '@/types/modal';
import styles from './DownloadCTASticky.module.scss';

import { useModalDispatch } from "@/context/ModalContext";
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';
import { calculateTimeDifference, formatWebinarDate, getIndianTime } from '@/LpRevamp/LpBanner/utils';


export default function DownloadCTASticky({ associatedPrograms,isWebinar=false,webinar=null,isPhoneNumber=false,updatedheader=null }) {
  const modalDispatch = useModalDispatch();
  const localTime=new Date().toISOString(); 
      const differenceInMinutes = calculateTimeDifference(webinar?.RegistrationDate, localTime);
      const ctaText=differenceInMinutes <= 60 && differenceInMinutes >= 0 ? "Join Now" : "Reserve your Spot";
      const formDisable=webinar?.isWebinarEnd



  if(!associatedPrograms.length)
    return null

  const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
  const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.SpecializationText || '';
  const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails

  const applyNowCTA = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalLP,
        modalData: {
          associatedPrograms,
          isLandingPage: true,
          webinar: webinar,
        },
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: isWebinar ? "Reserve Now" : "Apply Now",
        section_name: "Bottom Navigation Bar",
        page_type: getGlobalStateValue("pageType"),
      });

      window?.webengage?.track("Enquire Now Clicked");
    }, 1000);
  };

  const downloadBrochureCTA = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.DownloadBrochureLP,
        modalData: { specializationText, Custom10PgType, brochure, isMobile: true, programDetails },
      },
    });

    setTimeout(()=>{

      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Download Brochure",
        section_name: "Bottom Navigation Bar",
        page_type: getGlobalStateValue("pageType"),
      });

      window?.webengage?.track("Download Brochure Clicked");
      
    },1500)

   
  };
  const CustomButtonPhone = () => {

    const fireGTEvents = () => {
      pushToDataLayer({
        event: "call_now_clicked",
        cta_text: "Call Now",
        page_type: "Campaign Page",
        section_name: "Header",
        page_url: window.location.href,
      });
    };

    return (
      <>
          <a
            href={`${ updatedheader?.CTA?.href }`}
            className={styles.downloadBrochureContainer}
            style={{ textAlign:"center",fontSize:"12px" }}
            target={"_self"}
            onClick={fireGTEvents}
          >
            Call Now
          </a>
      </>
    );
  };

  return (
       !isWebinar ?(
        <div className={styles.downloadCTAContainer} id="botton-nav-container">
      {  isPhoneNumber?  <CustomButtonPhone />:
        <button onClick={downloadBrochureCTA} className={styles.downloadBrochureContainer}>
        Download Brochure
      </button>
      }
      <button onClick={applyNowCTA} className={styles.applyNowContainer}>
      Enquire Now
      </button>
        </div >
      ) :
      !formDisable && (
        <div className={styles.downloadCTAContainer} id="botton-nav-container">
        <button onClick={applyNowCTA} className={styles.webinarApplyNow}>
         {ctaText}
        </button>
        </div>
      )
  )
}
